import { IOnInit } from "angular";
import { GridConfiguration } from "../../../../../../../../records/views/recordGridView";
import { IQuery } from "../../../../../../../../records/server/query";
import { Record } from "../../../../../../../../records/server/crud";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../../../../../../records/grids/settings/gridSettingsService";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../../../../records/grids/columns/columnDefinitionService";
import { MachineConfigurationViewThreeRivers } from "../../../../../../models/machineConfiguration";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../../../../records/server/serverUtility";
import {
  MachineConfigurationCellClassService,
  vsServiceName as MachineConfigurationCellClassServiceName,
} from "../../../../../../../shared/machineConfigurationCellClassService";

export class MachineTypeIdInfoMachineEditComponentController
  implements IOnInit
{
  public readonly gridConfiguration!: GridConfiguration;
  public readonly typeId!: Record;

  public readonly defaultQuery: IQuery = {};
  public currentConfigurationsOnly = true;
  public currentTypeIdMachinesOnly = true;

  static $inject = [
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    ServerUtilityName,
    MachineConfigurationCellClassServiceName,
  ];
  constructor(
    private readonly gridSettingsService: GridSettingsService,
    private readonly columnDefinitionService: ColumnDefinitionService,
    private readonly serverUtility: ServerUtility,
    private readonly machineConfigurationCellClassService: MachineConfigurationCellClassService
  ) {}

  $onInit() {
    this.defaultQuery.MachineTypeIdId = this.typeId.Id;
    this.defaultQuery.CurrentConfiguration = true;

    this.gridConfiguration.gridSettings =
      this.gridSettingsService.getGridSettings(
        Symbol("machineTypeIdInfoEditMachines")
      );
    this.gridConfiguration.columns = [
      this.columnDefinitionService.getSelectColDef({
        headerName: "select",
      }),
      ...(this.gridConfiguration.columns ?? []),
    ];

    this.machineConfigurationCellClassService.styleColumns(
      this.gridConfiguration.columns,
      !this.currentConfigurationsOnly
    );
  }

  gridSelectionChanged(
    data: MachineConfigurationViewThreeRivers,
    selected: boolean
  ) {
    const machineTypeIdId = selected ? this.typeId.Id : undefined;
    const reset = machineTypeIdId ? [] : ["MachineTypeIdId"];

    this.serverUtility.patch({
      url: "/api/machines/MachineConfiguration",
      patchObject: {
        Id: data.MachineConfigurationId,
        MachineTypeIdId: machineTypeIdId,
        Reset: reset,
      },
    });
  }

  currentConfigurationsOnlyChanged(currentConfigurationsOnly: boolean) {
    this.defaultQuery.CurrentConfiguration = currentConfigurationsOnly
      ? true
      : undefined;
    this.machineConfigurationCellClassService.styleColumns(
      this.gridConfiguration.columns,
      !currentConfigurationsOnly
    );
  }

  currentTypeIdMachinesOnlyChanged(currentTypeIdMachinesOnly: boolean) {
    this.defaultQuery.MachineTypeIdId = currentTypeIdMachinesOnly
      ? this.typeId.Id
      : undefined;
  }
}
